import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import { CircularProgress } from '@mui/material';
import { GetOnestagetypeData, UpdateOnestagetypeData } from '../../Redux/Actions/StageTypeAction';
import { Notify } from '../../Utility/Notify';
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import { useSidebarWidth } from '../../Utility/useSidebarWidth';

export const UpdateStageType = () => {
  const theme        = useTheme();
  const isDark       = theme.palette.mode === 'dark';
  const dispatch     = useDispatch();
  const navigate     = useNavigate();
  const { id }       = useParams();
  const sidebarWidth = useSidebarWidth();

  const [name,              setName]              = useState('');
  const [comment,           setComment]           = useState('');
  const [loading,           setLoading]           = useState(true);
  const [updateTypeLoading, setUpdateTypeLoading] = useState(false);

  /* fetch one */
  useEffect(() => {
    dispatch(GetOnestagetypeData(id));
  }, [dispatch, id]);

  const res_update_stagetype = useSelector((s) => s.AllStagetype.stagetype);
  const stageData = res_update_stagetype?.data;

  useEffect(() => {
    if (stageData) {
      setName(stageData.name || '');
      setComment(stageData.Comment || '');
    }
  }, [stageData]);

  /* submit */
  const onSubmitupdate = async (e) => {
    e.preventDefault();
    if (!name.trim()) return Notify('error', 'Name is Required', 'error');
    setLoading(true);
    setUpdateTypeLoading(true);
    await dispatch(UpdateOnestagetypeData(id, { name: name.trim(), Comment: comment }));
    setLoading(false);
    setUpdateTypeLoading(false);
  };

  const res_update = useSelector((s) => s.AllStagetype.Updatestagetype);
  useEffect(() => {
    if (loading === false) {
      if (res_update?.status === 200) {
        Notify('success', 'Stage Type Updated Successfully', 'success');
      } else {
        Notify('error', 'Failed To Update Stage Type', 'error');
      }
      setLoading(true);
    }
  }, [loading]);

  /* ─── shared styles ─── */
  const inputStyle = {
    width: '100%', padding: '13px 16px', borderRadius: '10px',
    border: `1.5px solid ${isDark ? '#2d3248' : '#e2e8f0'}`,
    backgroundColor: isDark ? '#151827' : '#f8fafc',
    color: isDark ? '#f1f5f9' : '#0f172a',
    fontSize: '14px', outline: 'none', transition: 'all 0.2s',
    fontFamily: "'DM Sans', sans-serif", boxSizing: 'border-box',
  };
  const labelStyle = {
    display: 'block', fontSize: '11px', fontWeight: 700,
    letterSpacing: '0.08em', textTransform: 'uppercase',
    color: isDark ? '#9ca3af' : '#64748b', marginBottom: '8px',
  };
  const onFocus = (e) => {
    e.target.style.borderColor     = '#2563eb';
    e.target.style.backgroundColor = isDark ? '#1a1f35' : '#ffffff';
    e.target.style.boxShadow       = '0 0 0 3px rgba(37,99,235,0.12)';
  };
  const onBlur = (e) => {
    e.target.style.borderColor     = isDark ? '#2d3248' : '#e2e8f0';
    e.target.style.backgroundColor = isDark ? '#151827' : '#f8fafc';
    e.target.style.boxShadow       = 'none';
  };

  return (
    <div style={{
      position: 'fixed',
      top: '50px', left: sidebarWidth, right: 0, bottom: 0,
      transition: 'left 0.25s cubic-bezier(0.4,0,0.2,1)',
      overflowY: 'auto',
      background: isDark ? 'linear-gradient(135deg,#0f1117 0%,#1a1d2e 100%)' : '#f0f2f5',
      fontFamily: "'DM Sans','Segoe UI',sans-serif",
      marginTop: '10px',
    }}>

      {/* ── Breadcrumb ── */}
      <div style={{
        padding: '14px 28px',
        backgroundColor: isDark ? '#1a1d2e' : '#f0f2f5',
        display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', flexWrap: 'wrap',
      }}>
        <Link to="/AllLeadsForAdmin" style={{ textDecoration: 'none', color: isDark ? '#9ca3af' : '#6b7280', fontWeight: 500 }}>
          Home
        </Link>
        <span style={{ color: isDark ? '#4b5563' : '#d1d5db' }}>/</span>
        <Link to="/Stages" style={{ textDecoration: 'none', color: isDark ? '#9ca3af' : '#6b7280', fontWeight: 500 }}>
          Stages
        </Link>
        <span style={{ color: isDark ? '#4b5563' : '#d1d5db' }}>/</span>
        <Link to="/ShowAllstageTypes" style={{ textDecoration: 'none', color: isDark ? '#9ca3af' : '#6b7280', fontWeight: 500 }}>
          Stage Types
        </Link>
        <span style={{ color: isDark ? '#4b5563' : '#d1d5db' }}>/</span>
        <span style={{ color: isDark ? '#e5e7eb' : '#111827', fontWeight: 600 }}>Update Stage Type</span>
      </div>

      {/* ── Form ── */}
      <div style={{ padding: '28px 32px 48px' }}>
        <div style={{
          width: '100%', maxWidth: '720px',
          backgroundColor: isDark ? '#1e2132' : '#ffffff',
          borderRadius: '20px', padding: '36px 40px',
          boxShadow: isDark ? '0 24px 60px rgba(0,0,0,0.5)' : '0 4px 32px rgba(0,0,0,0.08)',
          border: isDark ? '1px solid #2a2f45' : '1px solid #e8eaf0',
        }}>

          {/* title */}
          <div style={{ marginBottom: '28px' }}>
            <h1 style={{
              fontSize: '22px', fontWeight: 700,
              color: isDark ? '#f1f5f9' : '#0d1b3e',
              margin: '0 0 4px', letterSpacing: '-0.4px',
            }}>
              Update Stage Type
            </h1>
            <p style={{ fontSize: '13px', color: isDark ? '#6b7280' : '#94a3b8', margin: 0 }}>
              Edit the stage type name and comment
            </p>
          </div>

          {/* Type Name */}
          <div style={{ marginBottom: '20px' }}>
            <label style={labelStyle}>Type Name *</label>
            <input
              style={inputStyle}
              value={name}
              onChange={(e) => setName(e.target.value)}
              type="text"
              placeholder="e.g. Follow Up, Closed, Interested"
              onFocus={onFocus}
              onBlur={onBlur}
              autoFocus
            />
          </div>

          {/* Comment */}
          <div style={{ marginBottom: '8px' }}>
            <label style={labelStyle}>Comment</label>
            <textarea
              style={{
                ...inputStyle,
                minHeight: '120px', resize: 'vertical',
                lineHeight: '1.6', padding: '13px 16px',
              }}
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              placeholder="Add a comment or description for this stage type…"
              onFocus={onFocus}
              onBlur={onBlur}
            />
          </div>

          {/* hint */}
          <p style={{ fontSize: '12px', color: isDark ? '#4b5563' : '#94a3b8', margin: '8px 0 0' }}>
            Fields marked with * are required
          </p>

          {/* divider */}
          <div style={{ height: '1px', backgroundColor: isDark ? '#2a2f45' : '#e8eaf0', margin: '28px 0' }} />

          {/* buttons */}
          <div style={{ display: 'flex', gap: '12px' }}>
            <button
              onClick={!updateTypeLoading ? onSubmitupdate : null}
              disabled={updateTypeLoading}
              type="button"
              style={{
                flex: 1, padding: '14px 24px', borderRadius: '10px', border: 'none',
                background: 'linear-gradient(135deg,#1e3a8a,#1d4ed8)',
                color: '#fff', fontSize: '13px', fontWeight: 700,
                letterSpacing: '0.08em', textTransform: 'uppercase',
                cursor: updateTypeLoading ? 'not-allowed' : 'pointer',
                opacity: updateTypeLoading ? 0.7 : 1,
                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
                transition: 'all 0.2s', boxShadow: '0 4px 16px rgba(29,78,216,0.35)',
                fontFamily: "'DM Sans',sans-serif",
              }}
              onMouseEnter={(e) => {
                if (!updateTypeLoading) {
                  e.currentTarget.style.transform = 'translateY(-1px)';
                  e.currentTarget.style.boxShadow = '0 6px 24px rgba(29,78,216,0.45)';
                }
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'none';
                e.currentTarget.style.boxShadow = '0 4px 16px rgba(29,78,216,0.35)';
              }}
            >
              {updateTypeLoading
                ? <><CircularProgress size={16} style={{ color: '#fff' }} /><span>Updating…</span></>
                : <><SyncAltIcon sx={{ fontSize: 17 }} /><span>Update Stage Type</span></>}
            </button>

            <button
              type="button"
              onClick={() => navigate('/ShowAllstageTypes')}
              style={{
                padding: '14px 28px', borderRadius: '10px',
                border: `1.5px solid ${isDark ? '#2d3248' : '#e2e8f0'}`,
                backgroundColor: 'transparent',
                color: isDark ? '#9ca3af' : '#64748b',
                fontSize: '13px', fontWeight: 700,
                letterSpacing: '0.08em', textTransform: 'uppercase',
                cursor: 'pointer', transition: 'all 0.2s',
                fontFamily: "'DM Sans',sans-serif",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = isDark ? '#4b5563' : '#94a3b8';
                e.currentTarget.style.color = isDark ? '#e5e7eb' : '#374151';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = isDark ? '#2d3248' : '#e2e8f0';
                e.currentTarget.style.color = isDark ? '#9ca3af' : '#64748b';
              }}
            >
              Cancel
            </button>
          </div>

        </div>
      </div>
    </div>
  );
};